/**
 * @file 结构文件
 * @author  fangsimin
 * @date    2018-12-21 10:46:18
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:28:50
 */

<template>
    <el-container class="cmp_mobile">
        <el-main>
            <CmpMobileHeader @openSideBar="openSideBar" :showSideBar="showSideBar" :alwaysShow="alwaysShow"/>
            <CmpSideBar v-if="showSideBar" @openSideBar="openSideBar" :activePath="activePath"/>
            <router-view class="cmpMobilePage"></router-view>
            <CmpMobileFooter />
        </el-main>
    </el-container>
</template>

<script>
import '@/modules/mobile/assets/style/common.scss';
import CmpMobileHeader from '@/modules/mobile/components/header.vue';
import CmpSideBar from '@/modules/mobile/components/sideBar.vue';
import CmpMobileFooter from '@/modules/mobile/components/footer.vue';

export default {
    name: 'app',
    components: {
        CmpMobileHeader,
        CmpSideBar,
        CmpMobileFooter
    },
    data() {
        return {
            showSideBar: false,
            alwaysShow: false,
            activePath: undefined
        };
    },
    watch: {
        '$route.path': {
            handler(val) {
                if (val) {
                    this.activePath = val;
                    if (val.indexOf('/business/mobile/partner-detail') > -1) {
                        this.alwaysShow = true;
                    }
                }
            },
            immediate: true
        }
    },
    mounted() {
        // console.log(window.navigator.userAgent);
    },
    methods: {
        openSideBar(flag) {
            this.showSideBar = flag;
        }
    }
};
</script>

<style lang="scss">
    html, body {
        margin: 0;
        padding: 0;
        height: 100%;
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    .cmp_mobile.el-container {
        // height: 100%;
        display: flex;
        flex-direction: column;
        padding-top: 0 !important;
        // -webkit-overflow-scrolling: touch;
        position: static;
        .el-main {
            padding: 0 !important;
            -webkit-overflow-scrolling: touch;
            position: static;
        }
    }
    #app {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/modules/mobile/App.vue